(() => {
  const initializeFaq = (root) => {
    if (!root || root.dataset.otkFaqReady === 'true') return;

    const search = root.querySelector('[data-otk-faq-search]');
    const items = [...root.querySelectorAll('[data-otk-faq-item]')];
    const noResults = root.querySelector('[data-otk-faq-no-results]');

    if (!search || !items.length) return;

    root.dataset.otkFaqReady = 'true';

    const filterItems = () => {
      const term = search.value.trim().toLocaleLowerCase();
      let matches = 0;

      items.forEach((item) => {
        const isMatch = !term || item.textContent.toLocaleLowerCase().includes(term);
        item.hidden = !isMatch;
        if (isMatch) matches += 1;
      });

      if (noResults) noResults.hidden = matches > 0;
    };

    search.addEventListener('input', filterItems);
  };

  const initializeAllFaqs = (container = document) => {
    container.querySelectorAll('[data-otk-faq]').forEach(initializeFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllFaqs());
  } else {
    initializeAllFaqs();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllFaqs(event.target));
})();
